module.exports = __webpack_public_path__ + "img/chevronright.b7226ed0.png";